import { InjectionToken } from '@angular/core';
import { gsap } from 'gsap/dist/gsap';
import { Draggable } from 'gsap/dist/Draggable';

gsap.registerPlugin(Draggable);

export const DraggableToken = new InjectionToken('Draggable', {
  factory: () => Draggable,
});
